var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export const withCodedErrorHandler = (verify, errorOptions) => (document, options
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore https://github.com/microsoft/TypeScript/issues/26781
) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        // Using return await to ensure async function execute in try block
        return yield verify(document, options);
    }
    catch (e) {
        const { message, code, codeString } = e;
        const { name, type, unexpectedErrorCode, unexpectedErrorString } = errorOptions;
        if (message && code && codeString) {
            return {
                name,
                type,
                data: e,
                reason: {
                    message,
                    code,
                    codeString,
                },
                status: "ERROR",
            };
        }
        else {
            return {
                name,
                type,
                data: e,
                reason: {
                    message: e.message,
                    code: unexpectedErrorCode,
                    codeString: unexpectedErrorString,
                },
                status: "ERROR",
            };
        }
    }
});
